// Promo Database — available promo actions during shows

export const PROMO_ACTIONS = [
  {
    id: 'self-promo',
    name: 'Self-Promo',
    cost: 2500,
    description: 'Features only 1 superstar, and can increase or lower their popularity based on performance.',
    participants: 1,
  },
  {
    id: 'call-out',
    name: 'Call-Out',
    cost: 3000,
    description: 'Chance to begin a 1v1 Rivalry or increase the level of an existing one.',
    participants: 2,
  },
  {
    id: 'role-change',
    name: 'Role Change',
    cost: 10000,
    description: 'Allows you to turn a superstar from face to heel, or vice-versa.',
    participants: 1,
  },
  {
    id: 'advertising',
    name: 'Advertising',
    cost: 0,
    description: 'Generates extra revenue, but could decrease a superstar\'s popularity in case of poor performance.',
    participants: 1,
  },
  {
    id: 'charity',
    name: 'Charity',
    cost: 15000,
    description: 'Generates a small bonus of fans for the week, and can increase the superstar\'s popularity.',
    participants: 1,
  },
  {
    id: 'class-change',
    name: 'Class Change',
    cost: 10000,
    description: 'Allows you to change a superstar class to their bonus perk class (secondary class).',
    participants: 1,
  },
  {
    id: 'training',
    name: 'Training',
    cost: 5000,
    description: "Increase the selected superstar's Ring XP.",
    participants: 1,
  },
  {
    id: 'tag-team-call-out',
    name: 'Tag Team Call-Out',
    cost: 3000,
    description: 'Chance to begin a Tag Team Rivalry or increase the level of an existing one.',
    participants: 4,
  },
  {
    id: 'invasion',
    name: 'Invasion',
    cost: 25000,
    description: 'Send a star to attack another brand and steal fans. Effectiveness depends on promo skill.',
    participants: 1,
    comingSoon: false,
  },
];
